import { render, staticRenderFns } from "./PaymentMethodPopup.vue?vue&type=template&id=fb01dc78"
import script from "./PaymentMethodPopup.vue?vue&type=script&lang=js"
export * from "./PaymentMethodPopup.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodPopup.vue?vue&type=style&index=0&id=fb01dc78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports